module.exports = __webpack_public_path__ + "static/media/Close-2.ae1a4cfc.JPG";